module.exports = __webpack_public_path__ + "img/ks.ae38db7a.png";